import { render, staticRenderFns } from "./QuestionnaireFormSection.vue?vue&type=template&id=2ff6f942"
import script from "./QuestionnaireFormSection.vue?vue&type=script&lang=js"
export * from "./QuestionnaireFormSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports